import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type PdfProps = {
    className?: string;
};

const Pdf: FunctionComponent<PdfProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'pdf'}
            viewBox="0 0 250 250"
        >
            <rect width="115.3" height="7" x="67.8" y="147.9" />
            <rect width="115.3" height="7" x="67.8" y="175.4" />
            <rect width="115.3" height="7" x="67.8" y="202.8" />
            <path d="M181.5 38h-113v85.9h113V38zm-7 78.9h-99V45h99v71.9z" />
            <path d="M27.4.7v248.1H224V.7H27.4zM215 239.8H36.4V9.7H215v230.1z" />
        </svg>
    );
};
export default Pdf;
